$('.js-c-footer-popup__close').on('click', function () {
  $('.js-c-footer-popup').hide();
})
